import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useEnableUser = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.users.setUserEnable(id, data),
    onError: (err) => {
      toaster.create({
        title: 'Не удалось изменить статус пользователя',
        description: err?.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Пользователь успешно разблокирован',
        type: 'success',
      })

      queryClient.invalidateQueries({ queryKey: ['userCard'] })
    },
  })
}
